import axios from "./axios";

export const getCycleFromLocalStorage = (): string => {
    return localStorage.getItem('cycle') || 'monthly';
};
export const createUser = async (endpoint, params) => {
    const response = await axios.post(`/${endpoint}`, params);
    return response.data;
}

export const searchUsername = async (params) => {
    const response = await axios.post(`/user/searchTable`, params);
    return response.data;
}

export const getUserData = async (targetId: string, fromDate: string, toDate: string) => {
    const cycle = getCycleFromLocalStorage();
    const response = await axios.get(`/users/table${targetId ? `?targetId=${targetId}&` : '?'}fromDate=${fromDate}&toDate=${toDate}&cycle=${cycle}`);
    return response.data;
}

export const getPlayersTable = async (params: { fromDate: string; toDate: string; filter: string; offset: number; limit: number; username?: string; }) => {
    const queryParams = new URLSearchParams({
        fromDate: params.fromDate,
        toDate: params.toDate,
        filter: params.filter,
        offset: params.offset.toString(),
        limit: params.limit.toString(),
        ...(params.username && { username: params.username })
    });
    const response = await axios.get(`/players/table?${queryParams}`);
    return response.data;
}

export const searchPlayer = async (params: { search: string; fromDate: string; toDate: string; }) => {
    const queryParams = new URLSearchParams({
        search: params.search,
        fromDate: params.fromDate,
        toDate: params.toDate
    });
    const response = await axios.get(`/admin/search-player?${queryParams}`);
    return response.data;
}

export const gateway = async (params: {
    type: 'get' | 'post' | 'patch';
    path: string;
    body?: any;
    options?: { headers?: Record<string, string> }
}) => {
    if (params.type === 'get') {
        const queryParams = new URLSearchParams({
            type: 'get',
            path: params.path
        });
        const config = params.options?.headers ? { headers: params.options.headers } : {};
        const response = await axios.get(`/admin/gateway?${queryParams}`, config);
        return response.data;
    } else {
        const response = await axios.post('/admin/gateway', {
            type: params.type,
            path: params.path,
            body: params.body,
            options: params.options
        });
        return response.data;
    }
}

export const agentDeposit = async (params: { target: string; amount: number; description: string; }) => {
    params['cycle'] = getCycleFromLocalStorage();
    const response = await axios.post(`/wallet/deposit`, params);
    return response.data;
}

export const agentWithdraw = async (params: { target: string; amount: number; description: string; }) => {
    params['cycle'] = getCycleFromLocalStorage();
    const response = await axios.post(`/wallet/withdraw`, params);
    return response.data;
}

export const agentPaymentBonus = async (params: { playerId: string; bonusAmount: number; }) => {
    const response = await axios.post(`/playerAgentBonus`, {
        ...params,
        cycle: getCycleFromLocalStorage()
    });
    return response.data;
}

export const playerBalance = async (params: { playerId: string; amount: number; type: string; }) => {
    const response = await axios.post(`/playerBalanceAdjustment`, params);
    return response.data;
}

export const getPlayerWager = async (startDate: string, endDate: string, type: string, fromRecord: number, toRecord: number, playerId: string, isOpenBet: boolean = false, isUser = false, isNative: boolean = false) => {
    const cycle = getCycleFromLocalStorage();
    const response = await axios.get(`/wager/getPlayerWagers?startDate=${startDate}&endDate=${endDate}&type=${type}&fromRecord=${fromRecord}&toRecord=${toRecord}&playerId=${playerId}&isOpenBet=${isOpenBet}&cycle=${cycle}&isUser=${isUser}&isNative=${isNative}`);
    return response.data;
}

export const getWagers = async (startDate: string, endDate: string, type: string, fromRecord: number, toRecord: number, isOpenBet: boolean = false) => {
    const cycle = getCycleFromLocalStorage();
    const response = await axios.get(`/wager/getTable?startDate=${startDate}&endDate=${endDate}&type=${type}&fromRecord=${fromRecord}&toRecord=${toRecord}&isOpenBet=${isOpenBet}&cycle=${cycle}`);
    return response.data;
}

export const getTransactions = async (params: { startDate: string, endDate: string, username: string, page: number, limit: number }) => {
    const response = await axios.post(`/transactions/getTransactions`, params);
    return response.data;
}

export const getPayments = async (params: { startDate: string, endDate: string, fromRecord: number, toRecord: number, cycle: string }) => {
    const response = await axios.get(`/payments/getPayments?startDate=${params.startDate}&endDate=${params.endDate}&fromRecord=${params.fromRecord}&toRecord=${params.toRecord}&cycle=${params.cycle}`);
    return response.data;
}

export const getCashbackTransactions = async (params: { startDate: string, endDate: string, fromRecord: number, toRecord: number }) => {
    const response = await axios.post(`/cashback/getTable`, params);
    return response.data;
}

export const updateUser = async (params: any) => {
    const response = await axios.post(`/user/update`, params);
    return response.data;
}

export const updatePlayerState = async (params: any) => {
    const response = await axios.post(`/player/updateState`, params);
    return response.data;
}

export const updatePlayerLimits = async (params: any) => {
    const response = await axios.post(`/player/updateLimits`, params);
    return response.data;
}

export const updatePlayerName = async (params: any) => {
    const response = await axios.post(`/player/updateName`, params);
    return response.data;
}

export const changePlayerPassword = async (params: any) => {
    const response = await axios.post(`/player/changePassword`, params);
    return response.data;
}

export const changePassword = async (params: any) => {
    const response = await axios.post(`/player/changePassword`, params);
    return response.data;
}

export const changeCurrentUserPassword = async (params: any) => {
    const response = await axios.post(`/user/changePassword`, params);
    return response.data;
}

export const getBalance = async () => {
    const cycle = getCycleFromLocalStorage();
    const path = cycle === 'weekly' ? '/session/getBalance?cycle=weekly' : '/session/getBalance';
    const response = await axios.post(path);
    return response.data;
}
export const loginAs = async (id: string) => {
    const response = await axios.get(`/auth/loginAs/${id}`);
    return response.data;
}

// Announcements CRUD
export const getAnnouncements = async () => {
    const response = await axios.get(`/announcement/get`);
    return response.data;
}

export const createAnnouncement = async (params: { title: string; text: string; startDate: string; endDate: string; state: string; }) => {
    const response = await axios.post(`/announcement/create`, params);
    return response.data;
}

export const updateAnnouncement = async (params: { id: number; title: string; text: string; startDate: string; endDate: string; state: string; }) => {
    const response = await axios.patch(`/announcement/update`, params);
    return response.data;
}

export const deleteAnnouncement = async (id: number) => {
    const response = await axios.delete(`/announcement/delete/${id}`);
    return response.data;
}
